import React from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";

interface TopPerformingAgentsProps {
  agents: { name: string; volume: number }[];
}

const TopPerformingAgents: React.FC<TopPerformingAgentsProps> = ({
  agents,
}) => {
  console.log("🔍 TopPerformingAgents: Data received:", agents);
  console.log("🔍 TopPerformingAgents: Data length:", agents?.length || 0);
  console.log("🔍 TopPerformingAgents: Has data?", agents && agents.length > 0);
  console.log("🔍 TopPerformingAgents: Total volume:", agents?.reduce((sum, a) => sum + (a.volume || 0), 0) || 0);

  const hasData = agents && agents.length > 0 && agents.some(a => (a.volume || 0) > 0);

  return (
    <Card className="w-full h-full flex flex-col">
      <CardHeader className="pb-4 mb-4 border-b border-gray-200 flex-shrink-0">
        <CardTitle className="text-accent text-2xl">Top Performing Agents</CardTitle>
        <CardDescription className="text-sm mb-2">Agents with the highest sales volume</CardDescription>
      </CardHeader>
      <CardContent className="pt-0 flex-1 min-h-0 flex flex-col">
        {!hasData ? (
          <div className="flex items-center justify-center h-[400px] text-muted-foreground text-sm">
            <p>No sales data available for agents</p>
          </div>
        ) : (
          <div className="mt-auto w-full flex items-end justify-start -mb-4">
            <ResponsiveContainer width="100%" height={400}>
            <BarChart data={agents} margin={{ top: 10, right: 15, left: 5, bottom: 80 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis 
                dataKey="name" 
                tick={{ fontSize: 11, fill: '#6b7280' }}
                angle={-45}
                textAnchor="end"
                height={80}
              />
              <YAxis 
                tick={{ fontSize: 11, fill: '#6b7280' }}
                tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
                width={60}
              />
              <Tooltip 
                formatter={(value: number) => [`$${value.toLocaleString()}`, 'Volume']}
                contentStyle={{ fontSize: '12px', padding: '8px' }}
                labelStyle={{ fontSize: '11px', marginBottom: '4px' }}
              />
              <Bar dataKey="volume" fill="hsl(var(--chart-1))" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
          </div>
        )}
      </CardContent>
      <CardFooter className="flex-shrink-0 border-t border-gray-100 pt-3 pb-3">
        <p className="text-sm text-muted-foreground leading-relaxed">
          <span className="font-medium text-foreground">Insight:</span> Sales performance of agents based on total revenue generated from client commissions.
        </p>
      </CardFooter>
    </Card>
  );
};

export default TopPerformingAgents;
